import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, onMounted, PropType, ref, watch } from "vue";
import GridFiltersBase from "@/components/ui/grid/grid-filters-base.vue";
import { FindWorkOrderFilters } from "@/types/find/work-orders/FindWorkOrderFilters";
import LookupSingleSelect from "@/components/ui/lookup/lookup-single-select.vue";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import SingleSelect from "@/components/ui/dropdowns/single-select.vue";
import { IDDescriptionPair } from "@/types/generic/IDDescriptionPair";
import { WorkOrderStatuses } from "@/enums/work-orders/WorkOrderStatuses";


export default /*#__PURE__*/_defineComponent({
  __name: 'filter-work-order-find-results',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /** 
     * Filters applied to the work order filter.
     @type {FindWorkOrderFilters} - An object defining the filter criteria.  
     */
  filters: {
    type: Object as PropType<FindWorkOrderFilters>,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
  /**
   * Emitted when filters are applied in the modal.
   * @property {Object} filters - The filter values applied to the work order list.
   */
  "filtersApplied",
],
  setup(__props, { emit }) {

const props = __props;





const showFilters = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

onMounted(async () => {
  clonePropFilters();
});

watch(
  () => props.modelValue,
  () => {
    if (!props.modelValue) {
      return;
    }
    // Need to clone the passed filters to avoid them updating before the user clicks the apply button
    clonePropFilters();
  },
);

/** Clones the prop filters so changes aren't applied until the user clicks the apply button */
const clonePropFilters = () => {
  /* To clone filters we can't use the spread command, as this only does a shallow clone.
   * To do a deep clone, we need to convert the filters to json and back to an array */
  if (props.filters) {
    modalFilter.value = JSON.parse(JSON.stringify(props.filters));
  }
};

const onFiltersApplied = () => emit("filtersApplied", modalFilter.value);

const modalFilter = ref<FindWorkOrderFilters>({
  status: { id: -1, description: "" },
  branch: { id: -1, description: "" },
});

const onClearFilters = () => {
  modalFilter.value.status = { id: -1, description: "" };
  modalFilter.value.branch = { id: -1, description: "" };
};

const statusValueChanged = (selectedDescription: string) => {
  modalFilter.value.status.description = selectedDescription;
};

const branchValueChanged = (selectedDescription: string) => {
  modalFilter.value.branch.description = selectedDescription;
};

const workOrderStatus = ref<IDDescriptionPair[]>([
  { id: WorkOrderStatuses.All, description: "All" },
  { id: WorkOrderStatuses.Estimate, description: "Estimate" },
  { id: WorkOrderStatuses.Pending, description: "Pending" },
  { id: WorkOrderStatuses.Outstanding, description: "Outstanding" },
  { id: WorkOrderStatuses.Completed, description: "Completed" },
  { id: WorkOrderStatuses.Closed, description: "Closed & Billed" },
  { id: WorkOrderStatuses.Archived, description: "Archived" },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GridFiltersBase, {
    "data-source": modalFilter.value,
    modelValue: showFilters.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showFilters).value = $event)),
    title: "Find Work Order Filters",
    onClearFilters: onClearFilters,
    onFiltersApplied: onFiltersApplied
  }, {
    filters: _withCtx(() => [
      _createVNode(SingleSelect, {
        modelValue: modalFilter.value.status.id,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modalFilter.value.status.id) = $event)),
        "data-source": workOrderStatus.value,
        label: "Status",
        showClearButton: true,
        onValueChanged: statusValueChanged
      }, null, 8, ["modelValue", "data-source"]),
      _createVNode(LookupSingleSelect, {
        label: "Branch",
        modelValue: modalFilter.value.branch.id,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modalFilter.value.branch.id) = $event)),
        "lookup-source": _unref(LookupTableSource).Sites,
        showClearButton: true,
        onValueChanged: branchValueChanged
      }, null, 8, ["modelValue", "lookup-source"])
    ]),
    _: 1
  }, 8, ["data-source", "modelValue"]))
}
}

})